/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CustomerBasicFromJSON, CustomerBasicToJSON, } from './CustomerBasic';
/**
 * Check if a given object implements the ProtocolBasic interface.
 */
export function instanceOfProtocolBasic(value) {
    if (!('customer' in value) || value['customer'] === undefined)
        return false;
    if (!('protocolId' in value) || value['protocolId'] === undefined)
        return false;
    if (!('protocolNumber' in value) || value['protocolNumber'] === undefined)
        return false;
    if (!('date' in value) || value['date'] === undefined)
        return false;
    if (!('meteringPointCount' in value) || value['meteringPointCount'] === undefined)
        return false;
    if (!('amount' in value) || value['amount'] === undefined)
        return false;
    if (!('invoiceFile' in value) || value['invoiceFile'] === undefined)
        return false;
    if (!('protocolFile' in value) || value['protocolFile'] === undefined)
        return false;
    if (!('hourlyReportFile' in value) || value['hourlyReportFile'] === undefined)
        return false;
    return true;
}
export function ProtocolBasicFromJSON(json) {
    return ProtocolBasicFromJSONTyped(json, false);
}
export function ProtocolBasicFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'customer': CustomerBasicFromJSON(json['customer']),
        'protocolId': json['protocol_id'],
        'protocolNumber': json['protocol_number'],
        'date': (new Date(json['date'])),
        'meteringPointCount': json['metering_point_count'],
        'amount': json['amount'],
        'invoiceFile': json['invoice_file'],
        'protocolFile': json['protocol_file'],
        'hourlyReportFile': json['hourly_report_file'],
    };
}
export function ProtocolBasicToJSON(json) {
    return ProtocolBasicToJSONTyped(json, false);
}
export function ProtocolBasicToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'customer': CustomerBasicToJSON(value['customer']),
        'protocol_id': value['protocolId'],
        'protocol_number': value['protocolNumber'],
        'date': ((value['date']).toISOString().substring(0, 10)),
        'metering_point_count': value['meteringPointCount'],
        'amount': value['amount'],
        'invoice_file': value['invoiceFile'],
        'protocol_file': value['protocolFile'],
        'hourly_report_file': value['hourlyReportFile'],
    };
}
